<template>
    <div class="number-games">
        <div class="number-games__box-header">
            <h1 class="number-games__box-header__title">{{ getTranslatedText('Fafi Mo-China') }}</h1>
            <div class="number-games__box-header__desctiption">
                <b>{{ getTranslatedText('Select your Fafi number/picture') }}</b>
                <span>{{ getTranslatedText('(up to 10 options allowed)') }}</span>
            </div>
        </div>
        <div class="number-games__list">
            <div
                class="number-games__item"
                :class="{ active: $store.state.dataActive.includes(v.number) }"
                v-for="(v, i) in listNumber"
                :key="i"
                @click="onAddToBetSlip(v)"
            >
                <img class="how-to-play__games-item-image" :src="addTimestampToURL(v.icon.active)" :alt="v.number" />
                <span class="number-games__item-number">{{ v.number }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import VersionCache from '@/mixins/version-cache/version-cache-mixins'
export default {
    mixins: [languageMixins, themeMixins, VersionCache],
    props: {
        listNumber: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dataActive: [],
        }
    },

    methods: {
        onAddToBetSlip(number) {
            let accountSetting = this.$store.state.accountSetting
            if (this.$store.state.betslip.length == accountSetting.max_line) {
                this.$store.dispatch('removeTobetslip', number)
                return false
            }
            this.$store.dispatch('addToBetslip', number)
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/games/index.scss';
</style>
